<template>
  <div>
    <banner choose-int="1506075601609252866"></banner>
    <bread jup-path="/address" jup-page="公司地址"></bread>
    <div class="contact-map" style="background-size: cover">
      <div class="con w1440">
        <div class="title" style="text-align: left">
          <h2 style="color: #2c3e50; margin-top: 10px">公司地址</h2>
        </div>
        <div class="map clearfix">
          <div class="right" id="map">
            <q-q-map></q-q-map>
          </div>
        </div>
      </div>
    </div>
    <customFooter></customFooter>
  </div>
</template>

<script>
import customFooter from "@/components/footer/footer";
import Bread from "@/components/bread/Bread";
import Banner from "@/components/banner/Banner";
import QQMap from "@/components/map/QQMap";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Address",
  components: {
    customFooter,
    Bread,
    Banner,
    QQMap,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.el-button.is-active,
.el-button:active {
  background: #fff;
  border-color: #dcdfe6;
  color: #222b36;
}

.el-button:focus,
.el-button:hover {
  background: #fff;
  border-color: #dcdfe6;
  color: #222b36;
}

.el-button {
  color: #222b36;
  background-color: #fff;
  border-color: #dcdfe6;
}

.el-button1.is-active,
.el-button1:active {
  background: #fff;
  border-color: #dcdfe6;
  color: #222b36;
}

.el-button1:focus,
.el-button1:hover {
  background: #fff;
  border-color: #dcdfe6;
  color: #222b36;
}

.el-button1 {
  color: #222b36;
  background-color: #fff;
  border-color: #dcdfe6;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
}
</style>
